import { debounce } from './utils/helpers';
import ScrollReveal from './animations/ScrollReveal';
import LazyVideo from './components/LazyVideo';
import Header from './components/Header';
import Work from './components/Work';
import Moodboard from './components/Moodboard';
import Accordion from './components/Accordion';
import VideosWithSound from './components/VideosWithSound';
import Blog from './components/Blog';

class Website {
  constructor() {
    this.wWidth = $(window).width();
    this.$body = $('body');

    this.header = new Header(this.wWidth);
    this.work = new Work(this.wWidth);
    this.moodboard = new Moodboard(this.wWidth);
    this.blog = new Blog(this.wWidth);

    this.faqs = $('.faqs').map((i, el) => {
      return new Accordion(el);
    });

    this.initObservers();
    this.initScrollingLinks();
    this.addEventListeners();

    this.videosWithSound = new VideosWithSound();
  }

  initScrollingLinks() {
    this.$links = $('a');

    this.$links.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const href = $cur.attr('href');
      const hrefArr = href.split('#');
      const { pathname, origin } = window.location;
      const dataOffset = $cur.data('offset');
      const dataHistory = $cur.data('history');

      // If the href is empty or just a hash, or if it's not a hash but the
      // path doesn't match the current page, do nothing.
      if (
        !href ||
        href === '#' ||
        (!href.startsWith('#') && !href.includes('#')) ||
        (!href.startsWith('#') &&
          hrefArr[0] !== pathname &&
          hrefArr[0] !== origin + pathname)
      ) {
        return;
      }

      const $target = href.startsWith('#') ? $(href) : $(`#${hrefArr[1]}`);
      if ($target.length) {
        e.preventDefault();

        const position = $target.offset().top;
        let offset = 200;

        if (dataOffset === 0) {
          offset = this.header.$container.outerHeight();
        }

        $('html, body').animate(
          {
            scrollTop: position - offset,
          },
          600,
        );

        if (dataHistory === 0) return;
        // update url hash
        window.history.pushState(null, null, href);
      }
    });

    // on load check if there is a hash in the url
    // if so, scroll to that section
    if (window.location.hash) {
      const $target = $(window.location.hash);

      if ($target.length) {
        const offset = $target.offset().top;

        // set initial position to top of page
        window.scrollTo(0, 0);

        setTimeout(() => {
          $('html, body').animate(
            {
              scrollTop: offset - 100,
            },
            600,
          );
        }, 500);
      }
    }
  }

  initObservers() {
    this.scrollReveal = new ScrollReveal(
      $(
        '.js-visibility:not(.is-visible), .js-visibility-inside>*:not(.is-visible)',
      ),
    );
    this.lazyVideos = new LazyVideo($('video'));
  }

  addEventListeners() {
    $(document).on('mousedown', this.onMouseDown.bind(this));
    $(document).on('keydown', this.onkeyDown.bind(this));

    const debouncedResize = debounce(this.onResize.bind(this), 500);
    $(window).on('resize', debouncedResize);
    $(window).on('scroll', this.onScroll.bind(this));

    document.addEventListener(
      'touchstart',
      this.onTouchStart.bind(this),
      false,
    );
    document.addEventListener('touchmove', this.onTouchMove.bind(this), false);
    document.addEventListener('touchend', this.onTouchEnd.bind(this), false);
  }

  onScroll() {
    if (this.header.onScroll) {
      this.header.onScroll();
      this.videosWithSound.onScroll();
    }
  }

  onTouchStart() {
    if (this.moodboard.onTouchStart) {
      this.moodboard.onTouchStart();
    }
  }

  onTouchMove() {
    if (this.moodboard.onTouchMove) {
      this.moodboard.onTouchMove();
    }
  }

  onTouchEnd() {
    if (this.moodboard.onTouchEnd) {
      this.moodboard.onTouchEnd();
    }
  }

  onMouseDown() {
    // Let the document know when the mouse is being used
    this.$body.removeClass('is-tab');
  }

  onkeyDown(event) {
    // Re-enable focus styling when Tab is pressed
    if (event.key === 'Tab') {
      this.$body.addClass('is-tab');
    }
  }

  onResize() {
    const width = $(window).width();

    // width has changed
    if (this.wWidth !== width) {
      this.wWidth = width;

      if (this.header.onResize) {
        this.header.onResize(this.wWidth);
      }

      if (this.work.onResize) {
        this.work.onResize(this.wWidth);
      }

      if (this.moodboard.onResize) {
        this.moodboard.onResize(this.wWidth);
      }

      if (this.blog.onResize) {
        this.blog.onResize(this.wWidth);
      }
    }
  }
}

$(document).ready(() => {
  // eslint-disable-next-line no-new
  new Website();
});
